module.exports = __webpack_public_path__ + "static/media/accupos.fccfcce7.jpg";